const riot = require('riot');

riot.tag2('module-provider-apple_gift_card', '<div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">特典を受け取る</div> </div> <div class="px24 mtn105"> <div class="w-full pb20 pt42 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb24"><img class="block h130 object-fit-contain" src="/images/apple_gift_card/logo.svg"></div> <div class="ts-hs text-gray_80 mb4">Apple Gift Card</div> <div class="f fc fb"> <div class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString()}</div> <div class="ts-hs text-gray_60">円分</div> </div> </div> <div class="mb80" if="{mode === &quot;input_mail&quot;}"> <div class="ts-ps text-gray_80 mb24">特典としてApple Gift Cardを受け取ることができます。受け取るメールアドレスをご入力ください。</div> <form onsubmit="{toConfirm}"> <input class="input w-full mb24" ref="email" placeholder="メールアドレス" required riot-value="{email}" type="{\'email\'}"> <label class="f fm fit-content cursor-pointer mb26"> <input class="checkbox mr10" type="checkbox" onchange="{onToggleAgree}"> <p class="ts-ps"> <a class="text-link" href="/campaigns/{opts.event.campaign_id}/terms">個人情報の取り扱い</a>に同意しました</p> </label> <button class="button size-l primary w-full mb26" disabled="{!agreeTerms}">確認</button> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{inputMessage}"></p> </form> </div> <div class="mb40" if="{mode === &quot;confirm_mail&quot;}"> <div class="ts-hs text-gray_80 mb24">メールアドレスのご確認</div> <div class="ts-ps text-gray_80 mb24">こちらのメールアドレスに noreply@incentive.repro.io から<br>Apple Gift Cardをお送りします。</div> <form onsubmit="{sendMail}"> <input class="input w-full mb24" readonly riot-value="{email}" type="{\'email\'}"> <button class="button size-l primary w-full mb30">メールアドレスを確定</button> </form> <div class="f fh mb30"> <button class="button size-xs text" type="button" onclick="{toInput}">メールアドレスを修正する</button> </div> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{confirmMessage}"></p> </div> </div>', 'module-provider-apple_gift_card,[data-is="module-provider-apple_gift_card"]{display:block}', 'class="w-full"', function(opts) {
    this.inputMessage = `© ${dayjs().format('YYYY')} iTunes K.K. All rights reserved.`;
    var confirm_message = `■Apple Gift Cardとは
    ・iPad、AirPods、Apple Watch、iPhone、MacBook、iCloudのストレージ、アクセサリなど、すべてのApple製品の購入に使えます。
    ・App Storeやサブスクリプションの支払い、さらにAppやゲーム、音楽、映画、テレビ番組などの購入にも使えます。
    ・誕生日プレゼントにも、感謝やお祝いのしるしにもふさわしいギフトです。
    ・ギフトカードはEメールで届きます。
    ・日本国内のすべてのApple Storeでの購入のほか、Apple Store App、apple.com、App Store、iTunes Store、Apple Music、Apple TV+、Apple Books、Apple Arcade、iCloud、Apple OneなどのAppleのサービスで利用できます。
    ・Apple Storeで購入の際には、未使用のギフトカードをApple Storeにお持ちください。
    ・Appleアカウントでのオンライン購入に利用するには、apple.com/redeemにアクセスして、カードの金額を残高にチャージしてください。
    ・そのほかのお支払いには利用できません。
    ・Apple Gift Cardの返品や払い戻しはできません。諸条件が適用されます。

    ■Apple Gift Cardの利用規約
    日本国内におけるAppleからの購入のみに利用できます。Apple Gift Cardに関するお問い合わせは、support.apple.com/giftcard をご覧いただくか、0120-277-535までお電話ください。Apple製品取扱店では利用できません。また、法律で定められている場合を除き、現金との引換、転売、払い戻し、または商品交換はできません。Appleは、Apple Gift Cardの不正使用に対して責任を負いません。諸条件が適用されます。apple.com/jp/go/legal/gc をご覧ください。これらの条件が法的権利に影響を及ぼすことはありません。Apple Gift Cardの有効期限はありません。発行：iTunes株式会社 © ${dayjs().format('YYYY')} iTunes K.K. All rights reserved.`;

    this.confirmMessage = confirm_message.replace(/^ +/gm, "");

    this.mode = 'input_mail'

    this.preload = async ({req}) => {
      var email = req.query.email;

      return {
        email,
      };
    };

    this.toConfirm = (e) => {
      e.preventDefault();
      this.email = this.refs.email.value;
      this.mode = 'confirm_mail';
      this.update();
    };

    this.toInput = () => {
      this.email = '';
      this.mode = 'input_mail';
      this.update();
    };

    this.sendMail = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      try {
        await app.api.child('ntt_card_solutions/publish').post({ onetime_hash: this.opts.onetimeHash, email: this.email });
        spat.router.push(`/receive?hash=${this.opts.onetimeHash}`);
      }
      catch (e) {
        console.error(e);
        spat.modal.open('modal-error', {statusCode: e.status});
      }
      finally {
        indicator.close();
      }
    };

    this.onToggleAgree = (e) => {
      this.agreeTerms = e.currentTarget.checked;
    };
});